// Util
import { SortUtil } from '@/utils/sortUtil';
import { ImageUtil } from '@/utils/imageUtil';

// Others
import config from '@/config/env-constants';
const moment = require('moment-timezone');
import _ from 'lodash';


function getCompanyDisplay(company) {
	if (company && !_.isEmpty(company)) {
		let status = company.isActive === 'true' ? 'active' : 'inactive';
		return company.name + " (" + status + ")";
	}
	return "";
}

function getStorageLocationDisplay(storageLocation) {
	if (!_.isEmpty(storageLocation)) {
		let status = storageLocation.isActive === 'true' ? 'active' : 'inactive';
		return storageLocation.name + " (" + status + ")";
	}
	return "";
}

function getCompanyItem(company) {
	return {
		id: company.id ? company.id : null,
		name: company.name,
		isActive: company.isActive,
		type: company.type,
		brand: company.brand,
		contactNo: company.contactNo
	}
}

function getStorageLocationItem(loc) {
	return {
		id: loc.id,
		name: loc.name,
		isActive: loc.isActive,
		geoaddress: loc.geoaddress,
		companyId: loc.companyId
	}
}

function getDriverItem(driver) {
	return {
		id: driver.userId,
		name: driver.name,
		company: driver.company,
		companyId: driver.companyId,
		assistants: '',
		isAccountable: false,
		license: ImageUtil.createMedia(driver.license)
	}
}

function getTransportationItem(transportation) {
	return {
		id: transportation.plateNo,
		name: transportation.plateNo,
		company: transportation.company,
		companyId: transportation.companyId,
		hasCheckingInterval: transportation.hasCheckingInterval,
		checkingInterval: transportation.checkingInterval,
	}
}

function getUserItem(user) {
	return {
		id: user.id,
		name: user.firstName + ' ' + user.lastName,
		companyId: user.companyId,
		type: user.type
	}
}

function getCompanyAccessItem(company) {
	return {
		id: company.id,
		name: company.name,
		description: company.description
	}
}

function getClientAccountItem(account) {
	return {
		id: account.id,
		accountNo: account.accountNo,
		status: account.status
	}
}


export const DropDownItemsUtil = {

	// individual option item retrieval
	getCompanyDisplay,
	getStorageLocationDisplay,
	getCompanyItem,
	getStorageLocationItem,
	getDriverItem,
	getTransportationItem,
	getUserItem,
	getCompanyAccessItem,
	getClientAccountItem,

	retrieveIndustries: (industries, hasOthers) => {
		let industryItems = [];

		// init value
		industryItems.push({
			value: null,
			text: ' - Please select - ',
		});

		_.forEach(industries, industry => {
			industryItems.push({
				value: industry.id,
				text: industry.name,
			});
		});

		// sort options by text
		industryItems = SortUtil.sortByAttr('text', industryItems);
		industryItems = _.uniqBy(industryItems, 'text');

		if (hasOthers) {
			// Others
			industryItems.push({
				value: 'Others',
				text: ' - Others - ',
			});
		}

		return industryItems;
	},

	retrieveCompanies: companies => {
		let companyItems = [{
			value: { ...config.companyDefaultValue },
			text: ' - Please select - '
		}];

		_.forEach(companies, company => {
			companyItems.push({
				value: getCompanyItem(company),
				text: getCompanyDisplay(company)
			});
		});

		// sort options by text
		companyItems = SortUtil.sortByAttr('text', companyItems);
		companyItems = _.uniqBy(companyItems, 'text');

		return companyItems;
	},

	retrieveActiveCompanies: companies => {
		let companyItems = [{
			value: { ...config.companyDefaultValue },
			text: ' - Please select - '
		}];

		_.forEach(companies, company => {
			if (company.isActive === 'true') {
				companyItems.push({
					value: getCompanyItem(company),
					text: company.name
				});
			}
		});

		// sort options by text
		companyItems = SortUtil.sortByAttr('text', companyItems);
		companyItems = _.uniqBy(companyItems, 'text');

		return companyItems;
	},

	retrieveAllCompanyAccess: companies => {
		let companyItems = [];

		_.forEach(companies, company => {
			companyItems.push({
				value: {
					id: company.id,
					name: company.name,
					description: company.description
				},
				text: company.name
			});
		});

		// sort options by text
		companyItems = SortUtil.sortByAttr('text', companyItems);
		companyItems = _.uniqBy(companyItems, 'text');

		return companyItems;
	},

	retrieveAssetOwners: companies => {
		let companyItems = [];

		companyItems.push({
			value: null,
			text: ' - Please select - '
		});

		_.forEach(companies, company => {
			if (company.type === 'Asset Service Provider' && (company.brand !== '' && company.isActive === 'true')) {
				companyItems.push({
					value: getCompanyItem(company),
					text: getCompanyDisplay(company)
				});
			}
		});

		// sort options by text
		companyItems = SortUtil.sortByAttr('text', companyItems);
		companyItems = _.uniqBy(companyItems, 'text');

		return companyItems;
	},

	retrieveConnectedCompanies: (connections, currCompany, includeCurrCompany = true, isAssetUserOnly = false) => {
		let companyItems = [];

		companyItems.push({
			value: { ...config.companyDefaultValue },
			text: ' - Please select - '
		});

		// include the company the current user belongs to
		if (includeCurrCompany) {
			let currCompanyOption = {
				value: getCompanyItem(currCompany),
				text: getCompanyDisplay(currCompany)
			};
			companyItems.push(currCompanyOption);
		}

		// include other connection companies
		_.forEach(connections, connection => {
			if (connection.companyId === currCompany.id && connection.isActive === 'true') {
				let conCompanyOption = {
					value: getCompanyItem(connection.connectedCompany),
					text: getCompanyDisplay(connection.connectedCompany)
				};

				let companyNamesArr = _.map(companyItems, 'text');
				if (!_.includes(companyNamesArr, connection.connectedCompany.name)) {
					companyItems.push(conCompanyOption);
				}
			}
		});

		if (isAssetUserOnly) {
			companyItems = _.filter(companyItems, o => {
				return o.value.type === 'Asset User';
			});
		}

		// sort options by text
		companyItems = SortUtil.sortByAttr('text', companyItems);
		companyItems = _.uniqBy(companyItems, 'text');

		return companyItems;
	},

	retrieveStorageLocations: storageLocations => {
		let storageLocationItems = [{
			value: null,
			text: ' - Please select - '
		}];

		storageLocationItems.push({
			value: null,
			text: ' - Please select - '
		});

		_.forEach(storageLocations, loc => {
			storageLocationItems.push({
				value: getStorageLocationItem(loc),
				text: getStorageLocationDisplay(loc)
			});
		});

		// sort options by text
		storageLocationItems = SortUtil.sortByAttr('text', storageLocationItems);
		storageLocationItems = _.uniqBy(storageLocationItems, 'text');

		return storageLocationItems;
	},

	retrieveActiveStorageLocations: storageLocations => {
		let storageLocationItems = [];

		storageLocationItems.push({
			value: { ...config.storageLocationDefaultValue },
			text: ' - Please select - '
		});

		_.forEach(storageLocations, loc => {
			if (loc.isActive === 'true') {
				storageLocationItems.push({
					value: getStorageLocationItem(loc),
					text: loc.name
				});
			}
		});

		// sort options by text
		storageLocationItems = SortUtil.sortByAttr('text', storageLocationItems);
		storageLocationItems = _.uniqBy(storageLocationItems, 'text');

		return storageLocationItems;
	},

	retrieveStorageLocationsByConnection: (connections, storageLocations, companyId, connectedCompanyId) => {
		let storageLocationItems = [];

		storageLocationItems.push({
			value: { ...config.storageLocationDefaultValue },
			text: ' - Please select - '
		});


		if (companyId === connectedCompanyId) {
			// retrieve from list of storage locations
			_.forEach(storageLocations, loc => {
				if (loc.companyId === companyId && loc.isActive === 'true') {
					storageLocationItems.push({
						value: getStorageLocationItem(loc),
						text: getStorageLocationDisplay(loc)
					});
				}
			});

		} else {
			// retrieve from list of connections
			_.forEach(connections, connection => {
				if (connection.companyId === companyId
					&& connection.connectedCompanyId === connectedCompanyId
					&& connection.isActive === 'true') {
					let storageLocationsArr = Object.values(connection.storageLocations);
					storageLocationsArr.forEach(loc => {
						if (loc.isIncluded === 'true') {
							storageLocationItems.push({
								value: {
									id: loc.id,
									name: loc.name,
									isActive: loc.isActive,
									geoaddress: loc.geoaddress,
									companyId: connection.connectedCompanyId
								},
								text: getStorageLocationDisplay(loc)
							});
						}
					});
				}
			});
		}

		// sort options by text
		storageLocationItems = SortUtil.sortByAttr('text', storageLocationItems);
		storageLocationItems = _.uniqBy(storageLocationItems, 'text');

		return storageLocationItems;
	},

	retrieveStorageLocationsByCompany: (companyId, storageLocations) => {
		let storageLocationItems = [];

		storageLocationItems.push({
			value: { ...config.storageLocationDefaultValue },
			text: ' - Please select - '
		});

		_.forEach(storageLocations, loc => {
			if (loc.companyId === companyId && loc.isActive === 'true') {
				storageLocationItems.push({
					value: getStorageLocationItem(loc),
					text: getStorageLocationDisplay(loc)
				});
			}
		});

		// sort options by text
		storageLocationItems = SortUtil.sortByAttr('text', storageLocationItems);
		storageLocationItems = _.uniqBy(storageLocationItems, 'text');

		return storageLocationItems;
	},

	retrieveAssetTypes: (assetTypes, activeOnly = false) => {
		let assetTypeItems = [];
		assetTypeItems.push({
			value: null,
			text: ' - Please select - '
		});

		_.forEach(assetTypes, type => {
			assetTypeItems.push({
				value: {
					id: type.id,
					name: type.name,
					origin: type.origin,
					originId: type.originId
				},
				text: type.name
			});
		});

		// include active asset types only
		if (activeOnly) {
			assetTypeItems = _.filter(assetTypeItems, o => {
				let id = o.value && o.value.id ? o.value.id : '-';
				let assetType = assetTypes && assetTypes[id] ? assetTypes[id] : null;
				return !assetType || assetType.isActive === 'true';
			});
		}

		// sort options by text
		assetTypeItems = SortUtil.sortByAttr('text', assetTypeItems);
		assetTypeItems = _.uniqBy(assetTypeItems, 'text');

		return assetTypeItems;
	},

	retrieveAssetTypesByOriginId: (assetTypes, originId, activeOnly = false) => {
		let assetTypeItems = [];
		assetTypeItems.push({
			value: { ...config.assetTypeDefaultValue },
			text: ' - Please select - '
		});

		_.forEach(assetTypes, type => {
			if (type.originId === originId) {
				assetTypeItems.push({
					value: {
						id: type.id,
						name: type.name,
						origin: type.origin,
						originId: type.originId
					},
					text: type.name
				});
			}
		});

		// include active asset types only
		if (activeOnly) {
			assetTypeItems = _.filter(assetTypeItems, o => {
				let assetType = assetTypes[o.value.id];
				return !assetType || (assetType.isActive === 'true');
			});
		}

		// sort options by text
		assetTypeItems = SortUtil.sortByAttr('text', assetTypeItems);
		assetTypeItems = _.uniqBy(assetTypeItems, 'text');

		return assetTypeItems;
	},

	retrieveAssetTypesByAccountability: (assetTypes, companyAssetPools, originId, activeOnly = false) => {
		let assetTypeItems = [];
		assetTypeItems.push({
			value: { ...config.assetTypeDefaultValue },
			text: ' - Please select - '
		});

		let accountableAssetTypeIds = _.map(_.filter(companyAssetPools, o => {
			return o.companyId === originId;
		}), 'assetTypeId');

		_.forEach(assetTypes, type => {
			if (accountableAssetTypeIds.includes(type.id) || type.originId === originId) {
				assetTypeItems.push({
					value: {
						id: type.id,
						name: type.name,
						origin: type.origin,
						originId: type.originId
					},
					text: type.name
				});
			}
		});

		// include active asset types only
		if (activeOnly) {
			assetTypeItems = _.filter(assetTypeItems, o => {
				let assetType = assetTypes[o.value.id];
				return !assetType || (assetType.isActive === 'true');
			});
		}

		// sort options by text
		assetTypeItems = SortUtil.sortByAttr('text', assetTypeItems);
		assetTypeItems = _.uniqBy(assetTypeItems, 'text');

		return assetTypeItems;
	},

	retrieveActiveDrivers: (users, hasOthers = true) => {
		let userItems = [];

		userItems.push({
			value: config.driverDefaultValue,
			text: ' - Please select - '
		});

		if (hasOthers) {
			userItems.push({
				value: config.driverOtherValue,
				text: ' - Others - '
			});
		}

		_.forEach(users, user => {
			if (user.isActive === 'true') {
				let name = user.firstName + ' ' + user.lastName;
				userItems.push({
					value: {
						id: user.id,
						name: name,
						company: user.company,
						companyId: user.companyId,
						assistants: '',
						isAccountable: false,
						license: ImageUtil.createMedia(user.driversLicense.image)
					},
					text: name
				});
			}
		});

		// sort options by text
		userItems = SortUtil.sortByAttr('text', userItems);
		userItems = _.uniqBy(userItems, 'text');

		return userItems;
	},

	retrieveActiveDriversByCompany: (users, currCompany) => {
		let userItems = [];

		userItems.push({
			value: config.driverDefaultValue,
			text: ' - Please select - '
		});

		_.forEach(users, user => {
			if (user.isActive === 'true' && user.companyId === currCompany.id) {
				let name = user.firstName + ' ' + user.lastName;
				userItems.push({
					value: {
						id: user.id,
						name: name,
						company: user.company,
						companyId: user.companyId,
						assistants: '',
						isAccountable: false,
						license: ImageUtil.createMedia(user.driversLicense.image)
					},
					text: name
				});
			}
		});

		// sort options by text
		userItems = SortUtil.sortByAttr('text', userItems);
		userItems = _.uniqBy(userItems, 'text');

		return userItems;
	},

	retrieveActiveUsers: users => {
		let userItems = [];

		userItems.push({
			value: config.userDefaultValue,
			text: ' - Please select - '
		});

		_.forEach(users, user => {
			if (user.isActive === 'true') {
				let name = user.firstName + ' ' + user.lastName;
				userItems.push({
					value: {
						id: user.id,
						name: name,
						companyId: user.companyId,
						type: user.type
					},
					text: name
				});
			}
		});

		// sort options by text
		userItems = SortUtil.sortByAttr('text', userItems);
		userItems = _.uniqBy(userItems, 'text');

		return userItems;
	},

	retrieveActiveUsersByCompany: (users, companyId) => {
		let userItems = [];

		userItems.push({
			value: config.userDefaultValue,
			text: ' - Please select - '
		});

		_.forEach(users, user => {
			if (user.isActive === 'true' && user.companyId === companyId) {
				let name = user.firstName + ' ' + user.lastName;
				userItems.push({
					value: {
						id: user.id,
						name: name,
						companyId: user.companyId,
						type: user.type
					},
					text: name
				});
			}
		});

		// sort options by text
		userItems = SortUtil.sortByAttr('text', userItems);
		userItems = _.uniqBy(userItems, 'text');

		return userItems;
	},

	retrieveManagersByCompany: (users, companyId) => {
		let userItems = [];

		userItems.push({
			value: config.userDefaultValue,
			text: ' - Please select - '
		});

		_.forEach(users, user => {
			if (user.isActive === 'true' && user.companyId === companyId && user.type === 'Manager') {
				let name = user.firstName + ' ' + user.lastName;
				userItems.push({
					value: {
						id: user.id,
						name: name,
						companyId: user.companyId,
						type: user.type
					},
					text: name
				});
			}
		});

		// sort options by text
		userItems = SortUtil.sortByAttr('text', userItems);
		userItems = _.uniqBy(userItems, 'text');

		return userItems;
	},

	retrieveTransportations: (transportations, hasOthers = true) => {
		let transportationItems = [];

		transportationItems.push({
			value: config.transportationDefaultValue,
			text: ' - Please select - '
		});

		if (hasOthers) {
			transportationItems.push({
				value: config.transportationOthersValue,
				text: ' - Others - '
			});
		}

		_.forEach(transportations, transportation => {
			if (transportation.isActive === 'true') {
				transportationItems.push({
					value: {
						id: transportation.plateNo,
						name: transportation.plateNo,
						company: transportation.company,
						companyId: transportation.companyId,
						hasCheckingInterval: transportation.hasCheckingInterval ? transportation.hasCheckingInterval : false,
						checkingInterval: transportation.checkingInterval ? transportation.checkingInterval : 0
					},
					text: transportation.plateNo
				});
			}
		});

		// sort options by text
		transportationItems = SortUtil.sortByAttr('text', transportationItems);
		transportationItems = _.uniqBy(transportationItems, 'text');

		return transportationItems;
	},

	retrievePlateNos: transportations => {
		let plateNoItems = [];

		plateNoItems.push({
			value: null,
			text: ' - Please select - '
		});

		_.forEach(transportations, transportation => {
			if (transportation.isActive === 'true') {
				plateNoItems.push({
					value: transportation.plateNo,
					text: transportation.plateNo
				});
			}
		});

		// sort options by text
		plateNoItems = SortUtil.sortByAttr('text', plateNoItems);
		plateNoItems = _.uniqBy(plateNoItems, 'text');

		return plateNoItems;
	},

	retrieveAssetCategories: (categories, hasOthers) => {
		let assetCategoryItems = [];

		assetCategoryItems.push({
			value: null,
			text: ' - Please select - ',
		});

		_.forEach(categories, category => {
			assetCategoryItems.push({
				value: category.name,
				text: category.name,
			});
		});

		// sort options by text
		assetCategoryItems = SortUtil.sortByAttr('text', assetCategoryItems);
		assetCategoryItems = _.uniqBy(assetCategoryItems, 'text');


		if (hasOthers) {
			// Others
			assetCategoryItems.push({
				value: 'Others',
				text: ' - Others - ',
			});
		}

		return assetCategoryItems;
	},

	retrieveUOMs: (uoms) => {
		let uomItems = [];

		uomItems.push({
			value: null,
			text: ' - Please select - '
		});

		_.forEach(uoms, uom => {
			uomItems.push({
				value: uom.id,
				text: uom.code + ' (' + uom.name + ')',
			});
		});

		// sort options by text
		uomItems = SortUtil.sortByAttr('text', uomItems);
		uomItems = _.uniqBy(uomItems, 'text');

		return uomItems;
	},

	retrieveConnectionTypes: (connectionTypes) => {
		let items = [];

		_.forEach(connectionTypes, connectionType => {
			items.push({
				value: connectionType.name,
				text: connectionType.name,
			});
		});

		// sort options by text
		items = SortUtil.sortByAttr('text', items);
		items = _.uniqBy(items, 'text');

		items.push({
			text: "Others",
			value: "Others"
		});

		return items;
	},

	retrieveIncidentTypes: (incidentTypes) => {
		let incidentTypeItems = [];

		incidentTypeItems.push({
			value: null,
			text: ' - Please select - '
		});

		_.forEach(incidentTypes, incidentType => {
			incidentTypeItems.push({
				value: {
					id: incidentType.id,
					name: incidentType.name,
				},
				text: incidentType.name,
			});
		});

		// sort options by text
		incidentTypeItems = SortUtil.sortByAttr('text', incidentTypeItems);
		incidentTypeItems = _.unionBy(incidentTypeItems, 'text');

		return incidentTypeItems;
	},

	getCompanyOptionById(companyOptions, companyId) {
		for (const option of companyOptions) {
			if (option.value && option.value.id === companyId) {
				return option.value;
			}
		}
		return { ...config.companyDefaultValue };
	},

	getUserOptionById(userOptions, userId) {
		for (const option of userOptions) {
			if (option.value && option.value.id === userId) {
				return option.value;
			}
		}
		return config.userDefaultValue;
	},

	getContractPeriodOptions(contractOptions, contract) {
		for (const option of contractOptions) {
			if (option.value && option.value === contract) {
				return option.value;
			}
		}
		return ' - Others - ';
	},

	retrieveDispatches: dispatches => {
		let dispatchItems = [];
		dispatchItems.push({
			value: { ...config.dispatchDefaultValue },
			text: ' - Please select - '
		});

		_.forEach(dispatches, dispatch => {
			dispatchItems.push({
				value: {
					id: dispatch.id,
					name: dispatch.dispatchId,
					dispatchId: dispatch.dispatchId,
				},
				text: dispatch.dispatchId
			});
		});

		// sort options by text
		dispatchItems = SortUtil.sortByAttr('text', dispatchItems);
		dispatchItems = _.uniqBy(dispatchItems, 'text');

		return dispatchItems;
	},

	retrieveYearOptions: () => {
		let items = [{
			text: ' - Please select - ',
			value: null
		}];

		const currentYear = moment().tz('Asia/Manila').format('YYYY');

		for (let i = 0; i < 10; i++) {
			items.push({
				text: currentYear - i,
				value: currentYear - i
			});
		}

		return items;
	},

	retrieveMonthOptions: () => {
		return [
			{
				text: ' - Please select - ',
				value: null
			},
			{
				text: 'January',
				value: 1,
			},
			{
				text: 'February',
				value: 2,
			},
			{
				text: 'March',
				value: 3,
			},
			{
				text: 'April',
				value: 4,
			},
			{
				text: 'May',
				value: 5,
			},
			{
				text: 'June',
				value: 6,
			},
			{
				text: 'July',
				value: 7,
			},
			{
				text: 'August',
				value: 8,
			},
			{
				text: 'September',
				value: 9,
			},
			{
				text: 'October',
				value: 10,
			},
			{
				text: 'November',
				value: 11,
			},
			{
				text: 'December',
				value: 12,
			}
		];
	},

	retrieveUserTypeOptions: (hasTransportPermission) => {
		let userTypes = [
			{ value: null, text: ' - Please select - ' },
			{ value: 'Manager', text: 'Manager' },
			{ value: 'Supervisor', text: 'Supervisor' },
			{ value: 'Scanner', text: 'Scanner' },
			{ value: 'Viewer', text: 'Viewer' }
		];

		if (hasTransportPermission) {
			userTypes.push({ value: 'Driver', text: 'Driver' })
		}

		// sort options by text
		userTypes = SortUtil.sortByAttr('text', userTypes);
		userTypes = _.unionBy(userTypes, 'text');

		return userTypes;
	},

	retrieveClientAccounts: (clientAccounts, activeOnly = false) => {
		let accountItems = [{
			value: config.clientAccountDefaultValue,
			text: ' - Please select - '
		}];

		if (clientAccounts && !_.isEmpty(clientAccounts)) {
			_.forEach(clientAccounts, account => {
				accountItems.push({
					value: {
						id: account.id,
						accountNo: account.accountNo,
						status: account.status
					},
					text: account.accountNo,
				});
			});

			// include active accounts only
			if (activeOnly) {
				accountItems = _.filter(accountItems, o => {
					return o.value.status === null || o.value.status === 'Active';
				});
			}

			// sort options by text
			accountItems = SortUtil.sortByAttr('text', accountItems);
			accountItems = _.unionBy(accountItems, 'text');
		}

		return accountItems;
	},

	retrieveChargeTypes: clientAccounts => {
		let chargeTypeItems = [
			{ text: ' - Please select - ', value: null },
			{ text: 'Rental', value: 'Rental' },
			{ text: 'Trucking', value: 'Trucking' }
		];

		_.forEach(clientAccounts, clientAccount => {
			let assetTypes = clientAccount.assetTypes;
			_.forEach(assetTypes, assetType => {
				let billableRates = assetType.billableRates;

				_.forEach(billableRates, billableRate => {
					chargeTypeItems.push({
						value: billableRate.condition,
						text: billableRate.condition,
					});
				});
			});
		});

		// sort options by text
		chargeTypeItems = SortUtil.sortByAttr('text', chargeTypeItems);
		chargeTypeItems = _.unionBy(chargeTypeItems, 'text');

		return chargeTypeItems;
	},

	retrieveChargeTypeAssetTypes: (clientAccount, chargeType) => {
		let assetTypeItems = [
			{ text: ' - Please select - ', value: { ...config.assetTypeDefaultValue } }
		];

		let assetTypes = clientAccount.assetTypes;
		if (chargeType === 'Rental') {
			_.forEach(assetTypes, assetType => {
				assetTypeItems.push({
					value: assetType,
					text: assetType.assetType,
				});
			});
		} else {
			_.forEach(assetTypes, assetType => {
				let billableRates = _.map(assetType.billableRates, 'condition');
				if (billableRates.includes(chargeType)) {
					assetTypeItems.push({
						value: assetType,
						text: assetType.assetType,
					});
				}
			});
		}

		// sort options by text
		assetTypeItems = SortUtil.sortByAttr('text', assetTypeItems);
		assetTypeItems = _.unionBy(assetTypeItems, 'text');

		return assetTypeItems;
	}
};
